var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM8 24V26H24V24C24 22.6739 23.4732 21.4021 22.5355 20.4645C21.5979 19.5268 20.3261 19 19 19H13C11.6739 19 10.4021 19.5268 9.46447 20.4645C8.52678 21.4021 8 22.6739 8 24ZM13.7039 16.5433C14.4319 16.8448 15.2121 17 16 17C17.5913 17 19.1174 16.3679 20.2426 15.2426C21.3679 14.1174 22 12.5913 22 11C22 9.4087 21.3679 7.88258 20.2426 6.75736C19.1174 5.63214 17.5913 5 16 5C15.2121 5 14.4319 5.15519 13.7039 5.45672C12.9759 5.75825 12.3145 6.20021 11.7574 6.75736C11.2002 7.31451 10.7583 7.97595 10.4567 8.7039C10.1552 9.43185 10 10.2121 10 11C10 11.7879 10.1552 12.5681 10.4567 13.2961C10.7583 14.0241 11.2002 14.6855 11.7574 15.2426C12.3145 15.7998 12.9759 16.2417 13.7039 16.5433Z",
    fill: "#8E8EA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5155dcd87446c3fab1329793ec0d3cd4.svg";
export { ForwardRef as ReactComponent };